import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class BearSkeleton1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.BEAR_SKELETON1;
}

export default BearSkeleton1PoiTileEntity;
